module.exports = __webpack_public_path__ + "static/media/dai.5b15a8c6.jpg";